export const iconFontAwesomeLogisticsPlaneLock = (
	<i className="fa-solid fa-plane-lock"></i>
);
